module.exports = "/_next/static/images/a2160b59691fa0da9e468ff92ed40375-roxinho-details-metalico-xs@2x.jpg.webp";